import React, { Component } from 'react'
import { getKioskDocument } from 'src/utils/helpers'

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideClickHandler extends Component {
  constructor(props) {
    super(props)

    this.wrapperRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    const kioskDocument = getKioskDocument()
    kioskDocument.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    const kioskDocument = getKioskDocument()
    kioskDocument.removeEventListener('mousedown', this.handleClickOutside)
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.props.onOutsideClick()
    }
  }

  render() {
    return <div ref={this.wrapperRef}>{this.props.children}</div>
  }
}
